import React, { useState, useEffect, useRef } from 'react';

import AudioImage from './components/audio-image';

import { removeHTMLScript } from '@laigu/utils/removeHTMLTag';
import filterBlackList from '@laigu/utils/filterBlackList';

import style from './index.less';

const createDuration = time => {
  const handleTime = window.parseInt(time);
  const minutes = window.parseInt(handleTime / 60);
  const seconds = handleTime % 60;
  let ret = `${minutes}’${seconds}”`;
  if (!minutes) {
    ret = `${seconds}”`;
  }
  return ret;
};

const MessageSound = props => {
  const { data } = props;
  const { mediaUrl } = data;
  const [playing, setPlaying] = useState(false);
  const [duration, setDuration] = useState('');

  const safeUrl = filterBlackList(removeHTMLScript(mediaUrl));

  const audioRef = useRef(null);

  const handlePlay = () => {
    if (audioRef && audioRef.current && !playing) {
      const audio = audioRef.current;
      audio.play().catch(e => {
        if (
          e.message === "play() failed because the user didn't interact with the document first. https://goo.gl/xX8pDD"
        ) {
          // https://jira.meiqia.com/browse/LIVECHAT-11561
        } else {
          throw e;
        }
      });
      setPlaying(true);
      setTimeout(() => {
        setPlaying(false);
      }, audio.duration * 1000);
    }
  };

  useEffect(() => {
    if (audioRef && audioRef.current) {
      const audio = audioRef.current;
      audio.addEventListener(
        'loadedmetadata',
        () => {
          setDuration(createDuration(audio.duration));
        },
        false
      );
    }
  }, []);

  return (
    <div onClick={handlePlay} className={style['message-sound']}>
      <audio ref={audioRef}>
        <source src={safeUrl} type="audio/mpeg" />
        <track kind="captions" />
      </audio>
      <AudioImage playing={playing} />
      <span className={style['sound-time']}>{duration || ''}</span>
    </div>
  );
};

export default MessageSound;
